const product_edit = {
    page_title: "商品信息",
    view_title: "查看商品",
    edit_title: "编辑商品",
    add_title: "新增商品",
    btn_createSize: "生成规格",
    fl_category: "商品分类",
    fl_brand: "商品品牌",
    fl_name: "商品名称",
    fl_serial: "商品货号",
    fl_labels: "商品标签",
    fl_unit: "计量单位",
    fl_material: "主含材质",
    fl_objects: "适用对象",
    fl_content: "商品介绍",
    fl_size: "商品规格",
    fl_quantity: "商品库存",
    fl_originPrice: "商品原价",
    fl_price: "商品价格",
    fl_warnQuantity: "库存预警",
    fp_category: "请选择商品分类",
    fp_brand: "请选择商品品牌",
    fp_name: "请输入商品名称",
    fp_serial: "请输入商品货号",
    form_ph5: "请选择商品标签",
    fp_unit: "请输入计量单位",
    fp_material: "请输入主含材质",
    fp_objects: "请输入适用对象",
    fp_content: "请输入商品介绍",
    form_ph10: "请输入商品规格",
    fp_quantity: "请输入商品库存",
    fp_originPrice: "请输入商品原价",
    fp_price: "请输入商品价格",
    fp_warnQuantity: "请输入商品库存预警",
    table_title: "商品规格表",
    tl_originPrice: "原价",
    tl_price: "销售价格",
    tl_quantity: "商品库存",
    tl_warnQuantity: "库存预警值",
    tl_skuNo: "SKU编号",
    btn_reUpdate: "重新上传",
    btn_update: "点击上传",
    photos_title: "商品相册",
    btn_mainPhoto: "商品主图",
    btn_setMain: "设为主图",
    btn_removePhoto: "删除图片",
    btn_reUpdatePhoto: "重新上传图片",
    btn_updatePhoto: "上传商品图片",
    row_label1: "价格",
    row_label2: "货号",
    row_newest: "上新",
    row_promotion: "促销",
    row_hot: "热销",
    row_recommend: "推荐",
    dialog_title1: "商品入库",
    dialog_label1: "新增库存",
    dialog_btn1: "搜索",
    em_priceRule: "商品价格必须小于等于商品原价",
    em_price: "请输入数字，且最多包含两位小数",
    em_serialRequire: "请输入货号",
    em_serialRule: "货号只能为数字",
    em_name: "请输入商品名称",
    em_quantity: "请输入商品库存",
    em_originalPrice: "请输入商品原价",
    em_shopPrice: "请输入商品价格",
    em_category: "请选择商品分类",
    em_brand: "请选择商品品牌",
    em_content: "请输入商品介绍",
    em_warnQuantity: "请输入商品库存预警",
    em_warnQuantityRule: "库存预警必须为数字值",
    em_photoMin: "至少留取一张主图",
    em_dateRequire: "请把表格中的数据填写后再提交",
    em_tatbleDate: "表格数据未填写完",
    em_priceWrong: "销售价格不可以大于原价",
    em_tablePriceRule: "规格表中价格只能输入数字,且最多两位小数",
    em_priceNeed: "价格只能输入数字,且最多两位小数"
};

export default product_edit;
